/* eslint-disable */
import _ from 'underscore';
import Backbone from 'backbone';
import * as _DataRepository from '@bingads-webui-campaign-legacy/adextension-shared/service/repository';
import * as _editorView from '@bingads-webui-campaign-legacy/adextension-call/view/extension-editor';
import previewTemplate from '@bingads-webui-campaign-legacy/adextension-call/template/preview.pug';
import associationsEditorBase from '@bingads-webui-campaign-legacy/adextension-associations-editor/view/index';
import dialogDecorator from '@bingads-webui-component-legacy/dialog/dialogDecorator';
import rowTemplate from '@bingads-webui-campaign-legacy/adextension-call/template/gridRowTemplate.pug';
import * as _panelDecorator from '@bingads-webui-campaign-react/panel-decorator';
var schema = window.globalLegacySchema.get('CallAdExtension');
var $i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/adextensions');
var DataRepository = _DataRepository.default;
var editorView = _editorView.default;
var panelDecorator = _panelDecorator.panelDecorator;
var dialogOptions = {
  position: 'center',
  maxWidth: 1000
};
var i18nKeys = {
  title: 'AdExtensions_Call_Editor_Title',
  subtitle: 'NewCampaign_CallAdExtension_Subtitle',
  library_title: 'AdExtensions_Call_Editor_Available',
  selected_title: 'AdExtensions_Call_Editor_Selected',
  create_link: 'AdExtensions_Call_Editor_CreateNew',
  create_title: 'AdExtensions_Call_Dialog_Title_Add',
  delete_btn: 'AdExtensions_Call_Editor_Delete',
  delete_confirm: 'AdExtensions_Call_Delete_Warning',
  edit_btn: 'AdExtensions_Call_Editor_Edit',
  edit_title: 'AdExtensions_Call_Dialog_Title_Edit',
  inlineAlert: 'AdExtensions_Call_Max_Select_Notification'
};
var view = associationsEditorBase.extend({
  initialize: function (options) {
    var Editor = options && options.usePanel ? panelDecorator(editorView, {
      i18n: $i18n,
      panelReadyAriaLabel: $i18n.getString('Association editor side panel opened'),
      panelClassName: options.panelClassName
    }) : dialogDecorator.decorate(editorView, dialogOptions);
    _.extend(options, {
      data: new DataRepository({
        schema: schema,
        afterChangeComitted: function () {
          if (_.isFunction(options.updateContext)) {
            options.updateContext(['AccountAdExtensionsGrid', 'CampaignAdExtensionsGrid', 'AdGroupAdExtensionsGrid']);
          }
        }
      }),
      template: {
        preview: previewTemplate,
        rowTemplate: rowTemplate
      },
      extensionType: 'CallExtension',
      maxSelectedItemsCount: 1,
      CreateForm: Editor,
      EditForm: Editor,
      i18nKeys: _.extend({}, i18nKeys, options.i18nKeys || ({}))
    });
    associationsEditorBase.prototype.initialize.call(this, options);
  }
});
export default view;

